import React, { Fragment, useState } from "react";
import { Collapse, Row, Col, Input } from "reactstrap";
import { showToast } from "../../../utils/helper";

import { getMessageAttachment } from "../../../services/api/internalMessages";
import arrow from "../../../../public/svg/keyboard_arrow_down.svg";
import cross from "../../../../public/svg/x-symbol-svgrepo-com.svg";

import style from "./NotificationCollapse.scss";

export const NotificationCollapse = ({ notification, handleNotificationRead }) => {
  const [collapseActive, setCollapseActive] = useState(false);

  const getFile = () => {
    getMessageAttachment({ InternalMessageId: notification.InternalMessageId })
      .then(({ response }) => {
        var a = document.createElement("A");
        a.href = `data:application/octet-stream;base64,${response.blobfile}`;
        a.download = `${notification.InternalMessageAttachmentName}.${notification.InternalMessageAttachmentExtension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((err) => {
        console.error(err);
        showToast("Error downloading file", true);
      });
  };

  if (!notification) return null;

  return (
    <Fragment>
      <div
        className={style.collapseRow}
        onClick={() => {
          setCollapseActive(!collapseActive);
        }}
      >
        <span className={collapseActive ? style.active : ""}>{notification.InternalMessageTitle}</span>
        <img
          src={arrow}
          alt="arrow image"
          className={`${style.arrow} ${collapseActive ? style.arrowActive : ""}`}
        />
      </div>
      <Collapse isOpen={collapseActive} className={style.collapse}>
        <p>
          <p>{notification.InternalMessageText}</p>
          {notification.InternalMessageAttachmentName && (
            <div>
              <a onClick={getFile} className={style.attachment}>
                <i className="fa fa-file-pdf-o" />{" "}
                {`${notification.InternalMessageAttachmentName}.${notification.InternalMessageAttachmentExtension}`}
              </a>
            </div>
          )}
        </p>
        <img
          src={cross}
          alt="cross image"
          className={style.cross}
          onClick={() => handleNotificationRead(notification)}
        />
      </Collapse>
    </Fragment>
  );
};
